import ApiError from "./ApiError";

export default class ComputerLimitExceeded extends ApiError{
}